/* eslint-disable */

// ** Module imports **
import React from 'react';
import { withCookies } from 'react-cookie';
import { connect } from 'react-redux';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';
import moment from 'moment';
import { withRouter } from 'react-router';

import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
// ** Material UI imports **
import Input, { InputLabel, InputAdornment } from 'material-ui/Input';
import { CircularProgress } from 'material-ui/Progress';
import { withStyles } from 'material-ui/styles';
import green from 'material-ui/colors/green';
import { FormControl, FormHelperText } from 'material-ui/Form';
import MenuItem from 'material-ui/Menu/MenuItem';
import TextField from 'material-ui/TextField';
import Button from 'material-ui/Button';
import Card, { CardHeader, CardContent } from 'material-ui/Card';
import Grid from 'material-ui/Grid';
import List from 'material-ui/List';
import ListItem from 'material-ui/List/ListItem';
import ListItemAvatar from 'material-ui/List/ListItemAvatar';
import ListItemSecondaryAction from 'material-ui/List/ListItemSecondaryAction';
import ListItemText from 'material-ui/List/ListItemText';
import ListSubheader from 'material-ui/List/ListSubheader';
import Typography from 'material-ui/Typography';

// ** React plugin **
import { Row, Col } from 'react-flexbox-grid';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import PlacesAutocomplete, {
  geocodeByAddress,
  getLatLng,
} from 'react-places-autocomplete';
import { ValidatorForm } from 'react-material-ui-form-validator';

// ** Assets **
import damMapIcon2 from '../assets/images/icon-map-dam-cotton.png';
import windTurbineMapIcon2 from '../assets/images/icon-map-wind-turbine-cotton.png';
import solarPanelMapIcon2 from '../assets/images/icon-map-solar-panel-cotton.png';
import geothermalIcon from '../assets/images/icons/geothermal.png';
import solidBiomassIcon from '../assets/images/icons/solid-biomass.png';
import woodIcon from '../assets/images/icons/wood.png';
import boltMapIcon2 from '../assets/images/icon-map-bolt-cotton.png';
import plusIcon from '../assets/images/icons/plus.png';
import deleteIcon from '../assets/images/icons/delete.png';
import createIcon from '../assets/images/icons/create.png';
import dataFlowIcon from '../assets/images/icons/data-flow.png';
import warningIcon from '../assets/images/icons/warning.png';
import trashIcon from '../assets/images/icons/trash.png';
import blockchainIcon from '../assets/images/blockchain.png';

// ** Custom components **
import InformationPopup from './commons/InformationPopup';

// ** Custom modules **
import { enums } from '../enums';
import { sanitize } from '../utils/text';
import { getTimeZones } from '../../src/utils/timeZone/TimeZones';
import {
  checkUserIsAdmin,
  checkUserIsSuperAdmin,
} from '../utils/user/checkAdmin/CheckAdmin';
import { addValidationRules } from '../../src/utils/formValidation/ValidationRules';
import { getRequiredErrorMessage } from '../../src/utils/formValidation/ErrorMessages';

// ** Actions **
import {
  displayedNameConsumingChanged,
  locationConsumingChanged,
  producingAssetsChanged,
  createAssetConsumingStart,
  updateAssetConsumingStart,
  getAssetsConsumingStart,
  getAssetConsumingFormStart,
  getAssetsProducingStart,
  resetCurrentAssetConsuming,
  reorderProducingAssetsList,
  displayPercentageChanged,
  matchingPercentageChanged,
  idChanged,
  nameConsumingChanged,
  archiveAssetConsumingStart,
  restoreAssetConsumingStart,
  timeZoneChanged,
  consAssetOrganizationChanged,
  consAssetCountryChanged,
  smireNameConsumingChanged,
  getOffchainConsSources,
  getOffchainConsSourceHistory,
  getOrganizations,
  getCountries,
} from '../actions';

const styles = theme => ({
  root: {
    display: 'flex',
    flexWrap: 'center',
  },
  margin: {
    margin: theme.spacing.unit,
  },
  withoutLabel: {
    marginTop: theme.spacing.unit * 3,
  },
  textField: {
    flexBasis: 200,
    margin: 20,
  },
  wrapper: {
    margin: theme.spacing.unit,
    position: 'relative',
  },
  buttonSuccess: {
    backgroundColor: green[500],
    '&:hover': {
      backgroundColor: green[700],
    },
  },
  buttonProgress: {
    color: green[500],
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12,
  },
});

const timeZones = getTimeZones();

const periodTypes = [
  {
    value: 'minute',
    label: 'Minute(s)',
  },
  {
    value: 'hour',
    label: 'Hour(s)',
  },
  {
    value: 'day',
    label: 'Day(s)',
  },
];

const aggregationPeriodTypes = [
  {
    value: 'minute',
    label: 'Minute(s)',
  },
  {
    value: 'hour',
    label: 'Hour(s)',
  },
  {
    value: 'day',
    label: 'Day(s)',
  },
  {
    value: 'month',
    label: 'Month(s)',
  },
  {
    value: 'year',
    label: 'Year(s)',
  },
];

//Start Drag and Drop functions
// fake data generator
const getItems = count =>
  Array.from({ length: count }, (v, k) => k).map(k => ({
    id: `item-${k}`,
    content: `item ${k}`,
  }));

// a little function to help us with reordering the result
const reorder = (list, startIndex, endIndex) => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);

  return result;
};

const grid = 8;

const getItemStyle = (isDragging, draggableStyle) => ({
  // some basic styles to make the items look a bit nicer
  userSelect: 'none',
  padding: 0,
  margin: `0 0 ${grid}px 0`,

  // change background colour if dragging
  background: isDragging ? 'rgb(0, 170, 255, 0.6)' : 'white',

  // styles we need to apply on draggables
  ...draggableStyle,
});

const getListStyle = isDraggingOver => ({
  background: isDraggingOver
    ? 'rgb(0, 170, 255, 0.2)'
    : 'rgb(0, 170, 255, 0.1)',
  padding: grid,
  width: '100%',
});
//End Drag and Drop functions

class FormAssetsConsuming extends React.Component {
  static contextTypes = {
    router: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      startDate: '',
      source: '',
      sourceID: '',
      periodNumber: 10,
      periodType: periodTypes[0].value,
      aggregationPeriodNumber: 1,
      aggregationPeriodType: aggregationPeriodTypes[2].value,
      sourceHistory: [],
      consSources: [],
      consSourcesList: [],
      sourceIds: [],
      items: getItems(4),
      prodAssetsList: [],
      prodAssetsListAllOrganizations: [],
      availableProdAssetsList: [],
      loadingProdAssets: false,
      assetConsumingType: 'Wind',
      assetConsumingCompliance: 'none',
      address: '',
      organizationId: '',
    };
    this.onDragEnd = this.onDragEnd.bind(this);
    this.handlePercentageChange = this.handlePercentageChange.bind(this);
    this.renderAssetProductionSites = this.renderAssetProductionSites.bind(
      this
    );
    this.renderAvailableAssetProductionSites = this.renderAvailableAssetProductionSites.bind(
      this
    );
  }

  accounts = [];

  componentDidMount = async () => {
    const { user, isAuthenticated, countries } = this.props;
    await populateConSourcesList(this.state);
    populateSourceIdsList(this.state);

    addValidationRules(ValidatorForm);

    if (!checkUserIsAdmin(isAuthenticated, user)) {
      this.props.history.push('/');
    } else {
      const {
        match: { params },
      } = this.props;

      this.setState({
        loadingProdAssets: true,
      });

      let allOrganizations = await this.props.getOrganizations();

      if (countries.length < 1) {
        await this.props.getCountries();
      }

      if (params.assetId) {
        // Update mode for selected asset
        await populateSourceHistory(this.state, params.assetId);

        let consAsset = await this.props.getAssetConsumingFormStart(
          params.assetId,
          this.props.history
        );
        let prodAssetsListFull = await this.props.getAssetsProducingStart();

        let prodAssetsList = prodAssetsListFull
          .filter(pA => {
            let relatedAsset = consAsset.producingAssets.find(pACons => {
              return pACons.id === pA.id;
            });

            return relatedAsset;
          })
          .map(pA => {
            let relatedAsset = consAsset.producingAssets.find(pACons => {
              return pACons.id === pA.id;
            });

            pA.priority = relatedAsset.priority;
            pA.percentage = relatedAsset.percentage;

            return pA;
          });

        prodAssetsList = prodAssetsList.sort((assetA, assetB) => {
          return assetB.priority - assetA.priority;
        });

        let availableProdAssetsList = prodAssetsListFull.filter(pA => {
          //The producing asset will be displayed in the available list if :
          // - it is not already attached to the consuming asset
          // - at least one of it's organizations is the utility organization

          //Check if the producing asset is not already attached to the consuming asset
          let relatedAsset = prodAssetsList.find(pACons => {
            return pACons.id === pA.id;
          });

          //Check if at least one of the producing asset organizations is the utility organization
          let utilityOrganization = consAsset.organization.parentOrganization;
          let hasUtilityOrganization = false;

          pA.organizations.map(o => {
            if (o.organization._id === utilityOrganization._id)
              hasUtilityOrganization = true;
          });
          return !relatedAsset && hasUtilityOrganization;
        });

        let organizationId = '';

        if (this.props.currentAssetConsuming.organization) {
          organizationId = this.props.currentAssetConsuming.organization._id;
        }

        this.setState({
          organizationId: organizationId,
          prodAssetsList,
          availableProdAssetsList,
          prodAssetsListAllOrganizations: prodAssetsListFull,
          loadingProdAssets: false,
        });
      } else {
        // Creation mode => new asset

        this.props.resetCurrentAssetConsuming();

        let prodAssetsListFull = await this.props.getAssetsProducingStart();

        this.setState({
          prodAssetsList: [],
          availableProdAssetsList: [],
          organizationId: '',
          prodAssetsListAllOrganizations: prodAssetsListFull,
          loadingProdAssets: false,
        });
      }
    }
  };

  onDragEnd(result) {
    // dropped outside the list
    if (!result.destination) {
      return;
    }

    this.state.prodAssetsList.map(pA => {});
    let newAssetsProducingList = reorder(
      this.state.prodAssetsList,
      result.source.index,
      result.destination.index
    );

    newAssetsProducingList = newAssetsProducingList.map((pA, index) => {
      pA.priority = newAssetsProducingList.length - 1 - index;
      return pA;
    });

    newAssetsProducingList.map(pA => {});

    this.setState({
      prodAssetsList: newAssetsProducingList,
    });

    let currentAssetConsumingProdAssetsList = newAssetsProducingList.map(pA => {
      return { id: pA.id, priority: pA.priority, percentage: pA.percentage };
    });

    this.handleProducingAssetsChange(currentAssetConsumingProdAssetsList);
  }

  onAddAssetClicked(assetId) {
    let prodAssetsList = this.state.prodAssetsList.map(pAsset => {
      if (pAsset.priority >= 0) pAsset.priority += 1;

      if (pAsset.id === assetId) {
        pAsset.priority = 0;
        pAsset.percentage = 10;
      }

      return pAsset;
    });

    let assetToAdd = this.state.availableProdAssetsList.find(pAsset => {
      return pAsset.id === assetId;
    });

    assetToAdd.priority = 0;
    assetToAdd.percentage = 0;

    prodAssetsList.push(assetToAdd);
    prodAssetsList = prodAssetsList.sort((assetA, assetB) => {
      return assetB.priority - assetA.priority;
    });

    let availableProdAssetsList = this.state.availableProdAssetsList.filter(
      pAsset => {
        return pAsset.id !== assetId;
      }
    );

    this.setState({ prodAssetsList, availableProdAssetsList });

    let currentAssetConsumingProdAssetsList = prodAssetsList.map(pA => {
      return { id: pA.id, priority: pA.priority, percentage: pA.percentage };
    });

    this.handleProducingAssetsChange(currentAssetConsumingProdAssetsList);
  }

  onRemoveAssetClicked(assetId) {
    const prodAssetToRemove = this.state.prodAssetsList.find(pAsset => {
      return pAsset.id === assetId;
    });

    const priority = prodAssetToRemove.priority;

    let prodAssetsList = this.state.prodAssetsList
      .map(pAsset => {
        if (pAsset.priority > priority && pAsset.id !== assetId) {
          pAsset.priority -= 1;
        }

        return pAsset;
      })
      .filter(pAsset => {
        return pAsset.id !== assetId;
      });

    prodAssetToRemove.priority = -1;
    prodAssetToRemove.percentage = 0;
    let availableProdAssetsList = this.state.availableProdAssetsList;
    availableProdAssetsList.push(prodAssetToRemove);

    this.setState({ prodAssetsList, availableProdAssetsList });

    let currentAssetConsumingProdAssetsList = prodAssetsList.map(pA => {
      return { id: pA.id, priority: pA.priority, percentage: pA.percentage };
    });

    this.handleProducingAssetsChange(currentAssetConsumingProdAssetsList);
  }

  onDragEndState(result, sortedAssetsProducing) {
    // dropped outside the list
    if (!result.destination) {
      return;
    }

    const prodAssetsList = reorder(
      this.state.prodAssetsList,
      result.source.index,
      result.destination.index
    );

    this.setState({
      prodAssetsList,
    });
  }

  parseGoogleResponse = components => {
    const formattedResult = {
      country: '',
      region: '',
      zip: '',
      city: '',
      street: '',
      houseNumber: '',
      gpsLatitude: '',
      gpsLongitude: '',
    };
    return getLatLng(components).then(gpsCoords => {
      formattedResult.gpsLatitude = gpsCoords.lat;
      formattedResult.gpsLongitude = gpsCoords.lng;

      components.address_components.map(component => {
        component.types.map(type => {
          if (type === 'route') {
            formattedResult.street = component.long_name;
          }
          if (type === 'street_number') {
            formattedResult.houseNumber = component.long_name;
          }
          if (type === 'locality') {
            formattedResult.city = component.long_name;
          }
          if (type === 'administrative_area_level_1') {
            formattedResult.region = component.long_name;
          }
          if (type === 'country') {
            formattedResult.country = component.long_name;
          }
          if (type === 'postal_code') {
            formattedResult.zip = component.long_name;
          }
        });
      });
      return formattedResult;
    });
  };

  handleAggregationPeriodTypeChange = () => event => {
    this.state.aggregationPeriodType = event.target.value;
    this.setState({ aggregationPeriodType: this.state.aggregationPeriodType });
  };

  handleAggregationPeriodNumberChange = () => event => {
    this.state.aggregationPeriodNumber = event.target.value;
    this.setState({
      aggregationPeriodNumber: this.state.aggregationPeriodNumber,
    });
  };

  handleTimeZoneChange = () => event => {
    this.props.timeZoneChanged(event.target.value);
  };

  handleOrganizationChange = () => event => {
    let organization = this.props.customerOrganizations.find(org => {
      return org._id === event.target.value;
    });

    if (organization) {
      let utilityOrganization = organization.parentOrganization;
      let availableProdAssetsList = this.state.prodAssetsListAllOrganizations.filter(
        pA => {
          //The producing asset will be displayed in the available list if at least one of it's organizations is the utility organization
          //Check if at least one of the producing asset organizations is the utility organization
          let hasUtilityOrganization = false;

          pA.organizations.map(o => {
            if (o.organization._id === utilityOrganization._id)
              hasUtilityOrganization = true;
          });
          return hasUtilityOrganization;
        }
      );

      this.setState({
        prodAssetsList: [],
        availableProdAssetsList,
        organizationId: organization._id,
      });
    } else {
      this.setState({
        prodAssetsList: [],
        availableProdAssetsList: [],
        organizationId: '',
      });
    }

    this.props.consAssetOrganizationChanged(organization);
  };

  handleCountryChange = () => event => {
    let country = this.props.countries.find(country => {
      return country._id === event.target.value;
    });

    this.props.consAssetCountryChanged(country);
  };

  handleAssetIdChange = () => event => {
    this.props.idChanged(event.target.value);
  };

  handleStartDateChange = newDate => {
    this.state.startDate = moment(newDate).format('YYYY-MM-DD');
    this.setState({ startDate: this.state.startDate });
  };

  handleSourceChange = () => event => {
    this.state.sourceID = '';
    this.setState({ sourceID: this.state.sourceID });

    let chosenSource = this.state.consSources.filter(
      source => source.name == event.target.value
    );
    let chosenSourceAssets = chosenSource[0].assets;

    this.state.sourceIds = chosenSourceAssets.map(asset => {
      return { value: asset.id };
    });

    this.state.source = event.target.value;
    this.setState({ source: this.state.source });
  };

  handleSourceIdChange = () => event => {
    this.setState({ sourceID: event.target.value });
  };

  addSourceHistoryItem = () => {
    this.state.sourceHistory.push({
      source: this.state.source,
      sourceID: this.state.sourceID,
      startDate: this.state.startDate,
      periodNumber: this.state.periodNumber,
      periodType: this.state.periodType,
      aggregationPeriodNumber: this.state.aggregationPeriodNumber,
      aggregationPeriodType: this.state.aggregationPeriodType,
    });
    this.setState({ sourceHistory: this.state.sourceHistory });
  };

  removeSourceHistoryItem = item => {
    const index = this.state.sourceHistory.indexOf(item);
    this.state.sourceHistory.splice(index, 1);
    this.setState({ sourceHistory: this.state.sourceHistory });
  };

  handleDisplayPercentageChange = () => event => {
    this.props.displayPercentageChanged(event.target.value);
  };
  handleMatchingPercentageChange = () => event => {
    this.props.matchingPercentageChanged(event.target.value);
  };

  handleDisplayedNameChange = () => event => {
    const {
      match: { params },
    } = this.props;

    let displayedName = event.target.value;
    this.props.displayedNameConsumingChanged(displayedName);
    this.props.nameConsumingChanged(displayedName);

    if (!params.assetId) {
      //only on asset creation
      let assetID = sanitize(displayedName);
      this.props.smireNameConsumingChanged(assetID);
      this.props.idChanged(assetID);
    }
  };

  handleSmireNameChange = () => event => {
    this.props.smireNameConsumingChanged(event.target.value);
  };
  handlePeriodNumberChange = () => event => {
    this.state.periodNumber = event.target.value;
    this.setState({ periodNumber: this.state.periodNumber });
  };
  handlePeriodTypeChange = () => event => {
    this.state.periodType = event.target.value;
    this.setState({ periodType: this.state.periodType });
  };

  handleOtherGreenAttributesChange = () => event => {
    this.props.otherGreenAttributesChanged(event.target.value);
  };

  handleTypeOfPublicSupportChange = () => event => {
    this.props.typeOfPublicSupportChanged(event.target.value);
  };

  handleTypeChange = () => event => {
    this.props.typeChanged(event.target.value);
  };

  handleComplianceChange = () => event => {
    this.props.registryComplianceChanged(event.target.value);
  };

  handleProducingAssetsChange = producingAssets => {
    this.props.producingAssetsChanged(producingAssets);
  };

  handleAddressChange = address => {
    this.setState({ address });
  };

  handleAddressSelect = address => {
    geocodeByAddress(address)
      .then(results => {
        return this.parseGoogleResponse(results[0]);
      })
      .then(formattedAddress => {
        let address = formattedAddress.houseNumber + ' ';
        address += formattedAddress.street
          ? formattedAddress.street + ', '
          : '';
        address += formattedAddress.zip ? formattedAddress.zip + ', ' : '';
        address += formattedAddress.city ? formattedAddress.city + ', ' : '';
        address += formattedAddress.region
          ? formattedAddress.region + ', '
          : '';
        address += formattedAddress.country
          ? formattedAddress.country + ' '
          : '';

        this.setState({ address });
        this.props.locationConsumingChanged(formattedAddress);
      })
      .catch(error => console.error('Error', error));
  };

  handlePercentageChange = assetId => event => {
    let newAssetsProducingList = this.state.prodAssetsList.map(pA => {
      if (pA.id === assetId) pA.percentage = event.target.value;
      return pA;
    });

    this.setState({
      prodAssetsList: newAssetsProducingList,
    });

    let currentAssetConsumingProdAssetsList = newAssetsProducingList.map(pA => {
      return { id: pA.id, priority: pA.priority, percentage: pA.percentage };
    });

    this.handleProducingAssetsChange(currentAssetConsumingProdAssetsList);
  };

  renderAssetProductionSites() {
    const { classes } = this.props;

    if (this.state.loadingProdAssets)
      return <CircularProgress size={24} className={classes.buttonProgress} />;

    return (
      <DragDropContext onDragEnd={result => this.onDragEnd(result)}>
        <Droppable droppableId="droppable">
          {(provided, snapshot) => (
            <div
              ref={provided.innerRef}
              style={getListStyle(snapshot.isDraggingOver)}
            >
              {this.state.prodAssetsList.map((pAsset, index) => {
                let assetIcon;

                switch (pAsset.assetType) {
                  case 0:
                    assetIcon = windTurbineMapIcon2;
                    break;
                  case 1:
                    assetIcon = solarPanelMapIcon2;
                    break;
                  case 2:
                    assetIcon = damMapIcon2;
                    break;
                  case 3:
                    assetIcon = woodIcon;
                    break;
                  case 4:
                    assetIcon = windTurbineMapIcon2;
                    break;
                  case 5:
                    assetIcon = geothermalIcon;
                    break;
                  case 6:
                    assetIcon = solidBiomassIcon;
                    break;
                  default:
                    assetIcon = boltMapIcon2;
                }

                return (
                  <Draggable
                    key={'prod-asset-' + pAsset.id}
                    draggableId={'prod-asset-' + pAsset.id}
                    index={index}
                  >
                    {(provided, snapshot) => (
                      <div
                        ref={provided.innerRef}
                        {...provided.draggableProps}
                        {...provided.dragHandleProps}
                        style={getItemStyle(
                          snapshot.isDragging,
                          provided.draggableProps.style
                        )}
                      >
                        <List>
                          <ListItem key={'related-asset-' + pAsset._id}>
                            <ListItemAvatar>
                              <img
                                src={assetIcon}
                                style={{
                                  maxHeight: 16,
                                  marginLeft: -10,
                                  position: 'absolute',
                                  top: 10,
                                }}
                              />
                            </ListItemAvatar>
                            <ListItemText
                              primary={
                                pAsset.displayedName +
                                ' (priority ' +
                                pAsset.priority +
                                ')'
                              }
                              secondary={
                                pAsset.organizations &&
                                pAsset.organizations.length > 0
                                  ? pAsset.organizations.map(o => {
                                      return (
                                        <Typography
                                          variant="body1"
                                          color="textSecondary"
                                          component="div"
                                        >
                                          {o.organization.name}{' '}
                                          {o.percentage * 100}%
                                        </Typography>
                                      );
                                    })
                                  : 'No organization'
                              }
                            />
                            <ListItemSecondaryAction>
                              <Button
                                onClick={() => {
                                  this.onRemoveAssetClicked(pAsset.id);
                                }}
                              >
                                <img
                                  src={trashIcon}
                                  style={{ maxHeight: 20 }}
                                />
                              </Button>
                            </ListItemSecondaryAction>
                          </ListItem>
                          <ListItem
                            key={'related-asset-' + pAsset._id + '-form'}
                          >
                            <FormControl
                              className={classNames(
                                classes.margin,
                                classes.textField
                              )}
                              style={{ marginTop: 0, marginBottom: 0 }}
                            >
                              <Input
                                id={'adornment-percentage-' + pAsset.id}
                                type="number"
                                value={
                                  pAsset && pAsset.percentage
                                    ? pAsset.percentage
                                    : 0
                                }
                                onChange={this.handlePercentageChange(
                                  pAsset.id
                                )}
                                autoComplete="percentage"
                                style={{ width: 100 }}
                                endAdornment={
                                  <InputAdornment position="end">
                                    %
                                  </InputAdornment>
                                }
                                inputProps={{
                                  'aria-label': 'Allocated percentage',
                                }}
                              />
                              <FormHelperText id="weight-helper-text">
                                Allocated percentage
                              </FormHelperText>
                            </FormControl>
                          </ListItem>
                        </List>
                      </div>
                    )}
                  </Draggable>
                );
              })}
              {provided.placeholder}
            </div>
          )}
        </Droppable>
      </DragDropContext>
    );
  }

  renderAvailableAssetProductionSites() {
    const { classes } = this.props;
    if (this.state.loadingProdAssets)
      return <CircularProgress size={24} className={classes.buttonProgress} />;
    if (this.state.availableProdAssetsList < 1)
      return (
        <Typography
          className={classes.title}
          variant="subheading"
          gutterBottom
          color="textSecondary"
          style={{
            fontSize: '0.875rem',
          }}
        >
          No producing asset
        </Typography>
      );

    return (
      <List dense={false}>
        {this.state.availableProdAssetsList.map((pAsset, index) => {
          let assetIcon;

          switch (pAsset.assetType) {
            case 4:
              assetIcon = windTurbineMapIcon2;
              break;
            case 1:
              assetIcon = solarPanelMapIcon2;
              break;
            case 2:
              assetIcon = damMapIcon2;
              break;
            case 5:
              assetIcon = geothermalIcon;
              break;
            case 6:
              assetIcon = solidBiomassIcon;
              break;
            default:
              assetIcon = boltMapIcon2;
          }

          return (
            <ListItem key={'available-asset-' + pAsset._id}>
              <ListItemAvatar>
                <img
                  src={assetIcon}
                  style={{
                    maxHeight: 16,
                    marginLeft: -10,
                    position: 'absolute',
                    top: 10,
                  }}
                />
              </ListItemAvatar>
              <ListItemText
                primary={pAsset.displayedName}
                secondary={
                  pAsset.organizations && pAsset.organizations.length > 0
                    ? pAsset.organizations.map(o => {
                        return (
                          <Typography
                            variant="body1"
                            color="textSecondary"
                            component="span"
                            key={
                              'available-asset-org-' +
                              pAsset._id +
                              '-' +
                              o.organization._id
                            }
                          >
                            {o.organization.name} {o.percentage * 100}%
                          </Typography>
                        );
                      })
                    : 'No organization'
                }
              />
              <ListItemSecondaryAction>
                <Button
                  onClick={() => {
                    this.onAddAssetClicked(pAsset.id);
                  }}
                >
                  <img src={plusIcon} style={{ maxHeight: 20 }} />
                </Button>
              </ListItemSecondaryAction>
            </ListItem>
          );
        })}
      </List>
    );
  }

  render() {
    const {
      classes,
      currentAssetConsuming,
      loading,
      customerOrganizations,
      countries,
      match: { params },
      isAuthenticated,
      user,
      t,
      cookies,
    } = this.props;

    let csrfToken = cookies.cookies._csrf;
    let isSuperAdmin = checkUserIsSuperAdmin(isAuthenticated, user);

    const buttonClassname = classNames({
      [classes.buttonSuccess]: loading,
    });

    let updatingAsset = false;
    if (params.assetId) {
      updatingAsset = true;
    }

    let fullAddress = currentAssetConsuming.houseNumber + ' ';
    fullAddress += currentAssetConsuming.street
      ? currentAssetConsuming.street + ', '
      : '';
    fullAddress += currentAssetConsuming.zip
      ? currentAssetConsuming.zip + ', '
      : '';
    fullAddress += currentAssetConsuming.city
      ? currentAssetConsuming.city + ', '
      : '';
    fullAddress += currentAssetConsuming.region
      ? currentAssetConsuming.region + ', '
      : '';
    fullAddress += currentAssetConsuming.country
      ? currentAssetConsuming.country + ' '
      : '';

    let dateFormat = 'yyyy/MM/dd'; //English date
    if (this.props.i18n.language === 'fr') {
      dateFormat = 'dd/MM/yyyy';
    } else if (this.props.i18n.language === 'en_us') {
      dateFormat = 'MM/dd/yyyy'; //American date
    }

    let dateTimeFormat = 'YYYY-MM-DD HH:mm'; //English date
    if (this.props.i18n.language === 'fr') {
      dateTimeFormat = 'DD-MM-YYYY HH:mm';
    } else if (this.props.i18n.language === 'en_us') {
      dateTimeFormat = 'MM-DD-YYYY h:mm a'; //American date
    }

    if (loading || this.state.loadingProdAssets) {
      return (
        <Grid container direction="row" justify="center" alignItems="stretch">
          <CircularProgress size={24} />
        </Grid>
      );
    }

    if (!customerOrganizations || customerOrganizations.length < 1) {
      const CONFIGURE_ORGANIZATION_MESSAGE =
        'There is no organization setup, please create at least one organization.';

      return <InformationPopup message={CONFIGURE_ORGANIZATION_MESSAGE} />;
    }

    return (
      <div className={classes.root}>
        <Grid container spacing={24}>
          <Grid item xs={12}>
            <Card className={classes.card}>
              <CardHeader
                avatar={<img src={createIcon} style={{ maxHeight: 20 }} />}
                title="Asset information"
              />
              <CardContent>
                <form>
                  <input type="hidden" name="_csrf" value={{ csrfToken }} />
                  <FormControl
                    className={classNames(classes.margin, classes.textField)}
                  >
                    <TextField
                      id="adornment-displayed-name"
                      label="Name"
                      type="text"
                      value={
                        currentAssetConsuming &&
                        currentAssetConsuming.displayedName
                          ? currentAssetConsuming.displayedName
                          : ''
                      }
                      onChange={this.handleDisplayedNameChange()}
                    />
                  </FormControl>
                  <FormControl
                    className={classNames(classes.margin, classes.textField)}
                  >
                    <TextField
                      id="adornment-smire-name"
                      label="Ref (can not be modified)"
                      disabled={true}
                      type="text"
                      helperText="Used to decrypt blockchain data"
                      value={
                        currentAssetConsuming && currentAssetConsuming.smireName
                          ? currentAssetConsuming.smireName
                          : ''
                      }
                      autoComplete="Smire Name"
                    />
                  </FormControl>
                  {isSuperAdmin && (
                    <FormControl
                      className={classNames(classes.margin, classes.textField)}
                    >
                      <TextField
                        id="adornment-asset-id"
                        label="Asset ID"
                        disabled={true}
                        type="text"
                        value={
                          currentAssetConsuming && currentAssetConsuming.assetID
                            ? currentAssetConsuming.assetID
                            : ''
                        }
                      />
                    </FormControl>
                  )}

                  <div>
                    <PlacesAutocomplete
                      value={
                        this.state.address ? this.state.address : fullAddress
                      }
                      onChange={this.handleAddressChange}
                      onSelect={this.handleAddressSelect}
                    >
                      {({
                        getInputProps,
                        suggestions,
                        getSuggestionItemProps,
                      }) => (
                        <FormControl
                          className={classNames(
                            classes.margin,
                            classes.textField
                          )}
                          style={{ width: '100%' }}
                        >
                          <InputLabel htmlFor="adornment-location">
                            Location
                          </InputLabel>
                          <Input
                            id="adornment-location"
                            {...getInputProps({
                              placeholder: 'Search Places ...',
                              className: 'location-search-input',
                            })}
                          />
                          <div className="autocomplete-dropdown-container">
                            {suggestions.map(suggestion => {
                              const className = suggestion.active
                                ? 'suggestion-item--active'
                                : 'suggestion-item';
                              const style = suggestion.active
                                ? {
                                    backgroundColor: '#fafafa',
                                    cursor: 'pointer',
                                    width: 'auto',
                                    color: 'rgba(0, 0, 0, 1)',
                                    height: 24,
                                    overflow: 'hidden',
                                    fontSize: '1rem',
                                    boxSizing: 'content-box',
                                    fontWeight: 'bold',
                                    lineHeight: '1.5em',
                                    fontFamily:
                                      '"Roboto", "Helvetica", "Arial", sans-serif',
                                    whiteSpace: 'nowrap',
                                    textOverflow: 'ellipsis',
                                    paddingLeft: 16,
                                    paddingRight: 16,
                                    paddingTop: 12,
                                    paddingBottom: 12,
                                  }
                                : {
                                    backgroundColor: '#ffffff',
                                    cursor: 'pointer',
                                    width: 'auto',
                                    color: 'rgba(0, 0, 0, 0.87)',
                                    height: 24,
                                    overflow: 'hidden',
                                    fontSize: '1rem',
                                    boxSizing: 'content-box',
                                    fontWeight: 400,
                                    lineHeight: '1.5em',
                                    fontFamily:
                                      '"Roboto", "Helvetica", "Arial", sans-serif',
                                    whiteSpace: 'nowrap',
                                    textOverflow: 'ellipsis',
                                    paddingLeft: 16,
                                    paddingRight: 16,
                                    paddingTop: 12,
                                    paddingBottom: 12,
                                  };
                              return (
                                <div
                                  {...getSuggestionItemProps(suggestion, {
                                    className,
                                    style,
                                  })}
                                >
                                  <span>{suggestion.description}</span>
                                </div>
                              );
                            })}
                          </div>
                        </FormControl>
                      )}
                    </PlacesAutocomplete>

                    <TextField
                      id="select-time-zone"
                      select
                      label="Time zone "
                      validators={['isRequired']}
                      errorMessages={[getRequiredErrorMessage()]}
                      className={classes.textField}
                      value={
                        currentAssetConsuming &&
                        currentAssetConsuming.momentTimezone
                          ? currentAssetConsuming.momentTimezone
                          : ' '
                      }
                      onChange={this.handleTimeZoneChange()}
                      SelectProps={{
                        MenuProps: {
                          className: classes.menu,
                        },
                      }}
                      margin="normal"
                      style={{ width: 140 }}
                    >
                      {timeZones.map(option => (
                        <MenuItem key={option.value} value={option.value}>
                          {option.value}
                        </MenuItem>
                      ))}
                    </TextField>

                    <TextField
                      id="select-organization"
                      select
                      label={t('Organization')}
                      className={classes.textField}
                      helperText={
                        <div>
                          <img
                            src={warningIcon}
                            style={{ marginRight: 10, width: 14 }}
                          />
                          Updating the organization will reset the matching
                          configuration
                        </div>
                      }
                      value={this.state.organizationId}
                      onChange={this.handleOrganizationChange()}
                      SelectProps={{
                        MenuProps: {
                          className: classes.menu,
                        },
                      }}
                      margin="normal"
                      style={{ flexBasis: 'auto' }}
                    >
                      <MenuItem value="">-</MenuItem>
                      {customerOrganizations.map(organization => (
                        <MenuItem
                          key={organization._id}
                          value={organization._id}
                        >
                          {organization.name}
                        </MenuItem>
                      ))}
                    </TextField>

                    <TextField
                      id="select-country"
                      select
                      label={t('Country')}
                      className={classes.textField}
                      value={
                        currentAssetConsuming.countryLink &&
                        currentAssetConsuming.countryLink._id
                          ? currentAssetConsuming.countryLink._id
                          : ''
                      }
                      onChange={this.handleCountryChange()}
                      SelectProps={{
                        MenuProps: {
                          className: classes.menu,
                        },
                      }}
                      margin="normal"
                      style={{ flexBasis: 'auto', width: 88 }}
                    >
                      {countries.map(country => (
                        <MenuItem key={country._id} value={country._id}>
                          {country.name}
                        </MenuItem>
                      ))}
                    </TextField>
                  </div>
                </form>
              </CardContent>
            </Card>
            <br />
            <Card className={classes.card}>
              <CardHeader
                avatar={<img src={dataFlowIcon} style={{ maxHeight: 20 }} />}
                title="Data acquisition"
              />
              <CardContent>
                <div>
                  <List dense={true}>
                    {currentAssetConsuming.source &&
                      currentAssetConsuming.sourceID &&
                      currentAssetConsuming.periodNumber &&
                      currentAssetConsuming.periodType &&
                      currentAssetConsuming.aggregationPeriodNumber &&
                      currentAssetConsuming.aggregationPeriodType && (
                        <div>
                          <ListSubheader>{'Current source : '}</ListSubheader>
                          <ListItem
                            key={'current-source-' + currentAssetConsuming._id}
                          >
                            <ListItemText
                              secondary="(Source)"
                              primary={
                                currentAssetConsuming.source
                                  ? currentAssetConsuming.source
                                  : ''
                              }
                            />
                            <ListItemText
                              secondary="(Source id)"
                              primary={
                                currentAssetConsuming.sourceID
                                  ? currentAssetConsuming.sourceID
                                  : ''
                              }
                            />
                            <ListItemText
                              secondary="(Aquisition)"
                              primary={
                                currentAssetConsuming.periodNumber &&
                                currentAssetConsuming.periodType
                                  ? currentAssetConsuming.periodNumber +
                                    ' ' +
                                    currentAssetConsuming.periodType
                                  : ''
                              }
                            />
                            <ListItemText
                              secondary="(Aggregation)"
                              primary={
                                currentAssetConsuming.aggregationPeriodNumber &&
                                currentAssetConsuming.aggregationPeriodType
                                  ? currentAssetConsuming.aggregationPeriodNumber +
                                    ' ' +
                                    currentAssetConsuming.aggregationPeriodType
                                  : ''
                              }
                            />
                          </ListItem>
                        </div>
                      )}
                    {!currentAssetConsuming.source && (
                      <ListSubheader>
                        {'Current source : No current source yet'}
                      </ListSubheader>
                    )}

                    {this.state.sourceHistory &&
                      this.state.sourceHistory.length > 0 && (
                        <ListSubheader>{'Source history : '}</ListSubheader>
                      )}
                    {this.state.sourceHistory &&
                      this.state.sourceHistory.length === 0 && (
                        <ListSubheader>{'No source history'}</ListSubheader>
                      )}

                    {this.state.sourceHistory.map(item => (
                      <ListItem
                        key={
                          'source-history-' +
                          item.source +
                          '-' +
                          item.sourceID +
                          '-' +
                          moment(item.startDate).format('YYYY-MM-DDTHH:mm')
                        }
                      >
                        <ListItemText
                          secondary="(Source)"
                          primary={item.source}
                        />

                        <ListItemText
                          secondary="(Source id)"
                          primary={item.sourceID}
                        />

                        <ListItemText
                          secondary="(Aquisition)"
                          primary={item.periodNumber + ' ' + item.periodType}
                        />
                        <ListItemText
                          secondary="(Aggregation)"
                          primary={
                            item.aggregationPeriodNumber +
                            ' ' +
                            item.aggregationPeriodType
                          }
                        />

                        <ListItemText
                          secondary="Start date"
                          primary={moment(item.startDate).format(
                            dateTimeFormat
                          )}
                        />

                        <ListItemSecondaryAction>
                          <Button
                            onClick={() => this.removeSourceHistoryItem(item)}
                          >
                            <img src={deleteIcon} style={{ maxHeight: 20 }} />
                          </Button>
                        </ListItemSecondaryAction>
                      </ListItem>
                    ))}
                    <ListSubheader>{'Create a new source : '}</ListSubheader>
                  </List>
                  <form
                    style={{ backgroundColor: '#fafafa', paddingBottom: 20 }}
                  >
                    <TextField
                      id="select-source"
                      select
                      label="Source"
                      className={classes.textField}
                      value={this.state.source ? this.state.source : ' '}
                      onChange={this.handleSourceChange()}
                      SelectProps={{
                        MenuProps: {
                          className: classes.menu,
                        },
                      }}
                      margin="normal"
                    >
                      {this.state.consSourcesList.map(option => (
                        <MenuItem key={option.value} value={option.value}>
                          {option.value}
                        </MenuItem>
                      ))}
                    </TextField>{' '}
                    <FormControl
                      className={classNames(classes.margin, classes.textField)}
                    >
                      <InputLabel htmlFor="adornment-source-id">
                        Source ID
                      </InputLabel>
                      <Input
                        id="adornment-source-id"
                        type="text"
                        value={this.state.sourceID}
                        autoComplete="Source ID"
                        onChange={this.handleSourceIdChange()}
                      />
                    </FormControl>
                    <FormControl
                      className={classNames(classes.margin, classes.textField)}
                    >
                      <MuiPickersUtilsProvider utils={DateFnsUtils}>
                        <KeyboardDatePicker
                          format={dateFormat}
                          openTo={'year'}
                          label="Start date"
                          value={
                            this.state.startDate
                              ? this.state.startDate
                              : moment().format('YYYY-MM-DD')
                          }
                          onChange={newDate => {
                            if (!moment(newDate).isValid() || !newDate) {
                              newDate = null;
                            }

                            this.handleStartDateChange(newDate);
                          }}
                          KeyboardButtonProps={{
                            'aria-label': 'change date',
                          }}
                          className={classes.inputWithMargin}
                        />
                      </MuiPickersUtilsProvider>
                    </FormControl>
                    <Grid item xs={12}>
                      <Row
                        style={{
                          marginLeft: 20,
                          marginRight: 20,
                          marginTop: 30,
                        }}
                      >
                        <Col xs={6}>
                          <Row>
                            <Typography
                              className={classes.title}
                              variant="body2"
                              gutterBottom
                              color="textSecondary"
                              style={{ fontSize: '0.875rem' }}
                            >
                              Acquisition frequency
                            </Typography>
                          </Row>
                          <Row>
                            <div>
                              <div style={{ float: 'left', marginTop: 25 }}>
                                <Typography
                                  className={classes.title}
                                  variant="body1"
                                  gutterBottom
                                  color="textSecondary"
                                  component="span"
                                  style={{
                                    fontSize: '0.875rem',
                                    float: 'left',
                                  }}
                                >
                                  Acquire data every
                                </Typography>
                              </div>
                              <div style={{ float: 'left' }}>
                                <FormControl
                                  className={classNames(
                                    classes.margin,
                                    classes.textField
                                  )}
                                >
                                  <Input
                                    style={{ fontSize: '13px', width: 40 }}
                                    id="adornment-period-number"
                                    type="text"
                                    value={
                                      this.state.periodNumber
                                        ? this.state.periodNumber
                                        : ''
                                    }
                                    autoComplete="Period number"
                                    onChange={this.handlePeriodNumberChange()}
                                  />
                                </FormControl>
                                <TextField
                                  style={{ fontSize: '13px', width: 140 }}
                                  id="select-period-type"
                                  select
                                  className={classes.textField}
                                  value={
                                    this.state.periodType
                                      ? this.state.periodType
                                      : periodTypes
                                  }
                                  onChange={this.handlePeriodTypeChange()}
                                  SelectProps={{
                                    MenuProps: {
                                      className: classes.menu,
                                    },
                                  }}
                                  margin="normal"
                                >
                                  {periodTypes.map(option => (
                                    <MenuItem
                                      key={option.value}
                                      value={option.value}
                                    >
                                      {option.label}
                                    </MenuItem>
                                  ))}
                                </TextField>
                              </div>
                            </div>
                          </Row>
                        </Col>
                        <Col xs={6}>
                          <Row>
                            <Typography
                              className={classes.title}
                              variant="body2"
                              gutterBottom
                              color="textSecondary"
                              style={{ fontSize: '0.875rem' }}
                            >
                              Aggregation frequency
                            </Typography>
                          </Row>

                          <Row>
                            <div>
                              <div style={{ float: 'left', marginTop: 25 }}>
                                <Typography
                                  className={classes.title}
                                  variant="body1"
                                  gutterBottom
                                  color="textSecondary"
                                  component="span"
                                  style={{
                                    fontSize: '0.875rem',
                                    float: 'left',
                                  }}
                                >
                                  Aggregate metering every
                                </Typography>
                              </div>
                              <div style={{ float: 'left' }}>
                                <FormControl
                                  className={classNames(
                                    classes.margin,
                                    classes.textField
                                  )}
                                >
                                  <Input
                                    id="adornment-aggregation-period-number"
                                    type="text"
                                    style={{ fontSize: '13px', width: 40 }}
                                    value={
                                      this.state.aggregationPeriodNumber
                                        ? this.state.aggregationPeriodNumber
                                        : ''
                                    }
                                    autoComplete="Aggregation Period Number"
                                    onChange={this.handleAggregationPeriodNumberChange()}
                                  />
                                </FormControl>
                                <TextField
                                  id="select-aggragation-period-type"
                                  select
                                  className={classes.textField}
                                  value={
                                    this.state.aggregationPeriodType
                                      ? this.state.aggregationPeriodType
                                      : ' '
                                  }
                                  onChange={this.handleAggregationPeriodTypeChange()}
                                  SelectProps={{
                                    MenuProps: {
                                      className: classes.menu,
                                    },
                                  }}
                                  margin="normal"
                                >
                                  {aggregationPeriodTypes.map(option => (
                                    <MenuItem
                                      key={option.value}
                                      value={option.value}
                                    >
                                      {option.label}
                                    </MenuItem>
                                  ))}
                                </TextField>
                              </div>
                            </div>
                          </Row>
                        </Col>
                      </Row>
                    </Grid>
                    <div style={{ marginLeft: 20, marginRight: 20 }}>
                      <Button
                        variant="flat"
                        color="primary"
                        component="span"
                        className={classes.button}
                        disabled={loading}
                        style={{
                          marginTop: 13,
                          border: '1px solid rgba(248,119,51, 0.5)',
                          borderRadius: 4,
                        }}
                        onClick={this.addSourceHistoryItem}
                      >
                        Add this source
                      </Button>
                    </div>
                  </form>
                </div>
              </CardContent>
            </Card>
            <br />
            <Card className={classes.card}>
              <CardHeader
                avatar={<img src={blockchainIcon} style={{ maxHeight: 20 }} />}
                title="Matching configuration"
              />
              <CardContent>
                <form>
                  <div>
                    <FormControl
                      className={classNames(classes.margin, classes.textField)}
                    >
                      <InputLabel htmlFor="adornment-display-percentage">
                        Display ratio
                      </InputLabel>
                      <Input
                        id="adornment-display-percentage"
                        type="text"
                        value={
                          currentAssetConsuming &&
                          currentAssetConsuming.displayPercentage
                            ? currentAssetConsuming.displayPercentage
                            : ''
                        }
                        autoComplete="Display Ratio"
                        onChange={this.handleDisplayPercentageChange()}
                      />
                    </FormControl>

                    <FormControl
                      className={classNames(classes.margin, classes.textField)}
                    >
                      <InputLabel htmlFor="adornment-matching-percentage">
                        Matching ratio
                      </InputLabel>
                      <Input
                        id="adornment-matching-percentage"
                        type="text"
                        value={
                          currentAssetConsuming &&
                          currentAssetConsuming.matchingPercentage
                            ? currentAssetConsuming.matchingPercentage
                            : ''
                        }
                        autoComplete="Matching Ratio"
                        onChange={this.handleMatchingPercentageChange()}
                      />
                    </FormControl>
                  </div>
                  <div>
                    <div>
                      <Grid container spacing={24}>
                        <Grid item xs={6}>
                          <div
                            style={{
                              color: 'rgba(0, 0, 0, 0.54)',
                              paddingBottom: 10,
                              fontSize: '1rem',
                              fontFamily: 'Inter-Regular',
                              lineHeight: 1,
                            }}
                          >
                            Available producing assets{' '}
                          </div>
                          {this.renderAvailableAssetProductionSites()}
                        </Grid>
                        <Grid item xs={6}>
                          <div
                            style={{
                              color: 'rgba(0, 0, 0, 0.54)',
                              paddingBottom: 10,
                              fontSize: '1rem',
                              fontFamily: 'Inter-Regular',
                              lineHeight: 1,
                            }}
                          >
                            Related producing assets{' '}
                          </div>
                          {this.renderAssetProductionSites()}
                        </Grid>
                      </Grid>
                    </div>
                  </div>
                </form>
              </CardContent>
            </Card>
            <div
              className={classes.wrapper}
              style={{ margin: 20, float: 'right' }}
            >
              <Button
                variant="raised"
                color="primary"
                className={buttonClassname}
                disabled={loading}
                onClick={() => {
                  updatingAsset
                    ? this.props.updateAssetConsumingStart(
                        this.props.currentAssetConsuming,
                        this.props.history,
                        this.state.sourceHistory
                      )
                    : this.props.createAssetConsumingStart(
                        this.props.currentAssetConsuming,
                        this.props.history,
                        this.state.sourceHistory
                      );
                }}
              >
                {updatingAsset ? 'Update asset' : 'Create asset'}
              </Button>
              {loading && (
                <CircularProgress
                  size={24}
                  className={classes.buttonProgress}
                />
              )}{' '}
              {updatingAsset &&
                currentAssetConsuming &&
                !currentAssetConsuming.active && (
                  <Button
                    variant="raised"
                    color="secondary"
                    className={buttonClassname}
                    disabled={loading}
                    onClick={() =>
                      this.props.restoreAssetConsumingStart(
                        this.props.currentAssetConsuming,
                        this.props.history
                      )
                    }
                  >
                    Restore asset
                  </Button>
                )}
              {updatingAsset &&
                currentAssetConsuming &&
                currentAssetConsuming.active && (
                  <Button
                    variant="raised"
                    color="secondary"
                    className={buttonClassname}
                    disabled={loading}
                    onClick={() =>
                      this.props.archiveAssetConsumingStart(
                        this.props.currentAssetConsuming,
                        this.props.history
                      )
                    }
                  >
                    Archive asset
                  </Button>
                )}
            </div>
          </Grid>
        </Grid>
      </div>
    );
  }
}

FormAssetsConsuming.contextTypes = {
  router: PropTypes.object,
};
FormAssetsConsuming.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapStateToProps = ({
  assetsConsumingReducer,
  assetsProducingReducer,
  router,
  loginReducer,
  organizationsReducer,
  countriesReducer,
}) => {
  const {
    assetsConsuming,
    currentAssetConsuming,
    loading,
  } = assetsConsumingReducer;
  const {
    organizations,
    utilityOrganizations,
    customerOrganizations,
  } = organizationsReducer;
  const { assetsProducing } = assetsProducingReducer;
  const { countries } = countriesReducer;

  const { location } = router;
  const { isAuthenticated, username, user } = loginReducer;
  return {
    assetsConsuming,
    assetsProducing,
    currentAssetConsuming,
    loading,
    location,
    isAuthenticated,
    username,
    user,
    organizations,
    utilityOrganizations,
    customerOrganizations,
    countries,
  };
};

const mapDispatchToProps = {
  displayedNameConsumingChanged,
  locationConsumingChanged,
  producingAssetsChanged,
  createAssetConsumingStart,
  updateAssetConsumingStart,
  getAssetsConsumingStart,
  getAssetConsumingFormStart,
  getAssetsProducingStart,
  resetCurrentAssetConsuming,
  reorderProducingAssetsList,
  displayPercentageChanged,
  matchingPercentageChanged,
  idChanged,
  nameConsumingChanged,
  archiveAssetConsumingStart,
  restoreAssetConsumingStart,
  timeZoneChanged,
  consAssetOrganizationChanged,
  consAssetCountryChanged,
  smireNameConsumingChanged,
  getOrganizations,
  getCountries,
};

FormAssetsConsuming = withStyles(styles, { name: 'FormAssetsConsuming' })(
  FormAssetsConsuming
);
FormAssetsConsuming = translate('translations')(FormAssetsConsuming);

/*Helper functions*/
const populateConSourcesList = async state => {
  state.consSources = await getOffchainConsSources('Consumption');
  state.consSourcesList = state.consSources.map(s => {
    return { value: s.name };
  });
};

const populateSourceIdsList = state => {
  let sourceIdsArray = [];
  for (let s of state.consSources) {
    for (let asset of s.assets) sourceIdsArray.push(asset.id);
  }
  state.sourceIds = sourceIdsArray.map(AssetId => {
    return { value: AssetId };
  });
};

const populateSourceHistory = async (state, assetId) => {
  state.sourceHistory = await getOffchainConsSourceHistory(assetId);
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(withCookies(FormAssetsConsuming))
);



// WEBPACK FOOTER //
// ./src/components/FormAssetsConsuming.js